import { useState, useMemo } from 'react';
import Session from '../shared/Session';
import Typography from '@mui/material/Typography';
import { TextField } from '@mui/material';
import { DateTimeWidget } from '../core/DateTimeWidget';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import CircularProgress from '@mui/material/CircularProgress';


export default function Applications() {
    const [orgData, setOrgData]: [any, any] = useState([]);

    useMemo(() => {
        Session.api("GET", "/organizations/?hydrated=true", {}, setOrgData);
    }, []);

    function reloadData() {
        Session.api("GET", "/organizations/?hydrated=true", {}, setOrgData);
    }

    let orgs: any[] = [];
    for (const org of orgData) {
        let providers = [];
        for (const provider of org.providers) {
            let deployments = [];
            for (const deployment of provider.deployments) {
                let apps = [];
                for (const app of deployment.applications) {
                    let fqdn = app.fqdn;
                    if (deployment.test_fqdns) {
                        fqdn = `${deployment.slug}.${app.slug}.${org.domain}`
                    }
                    if (fqdn.startsWith("*")) {
                        fqdn = fqdn.replace("*", "wildcard-subdomain-example");
                    }
                    apps.push(<div style={{ marginLeft: "3%" }} key={app.id + "-container"}>
                        <Typography key={app.id + "-app-header"} variant="h6" align="left" gutterBottom component="h4">
                            {app.name} ({app.slug})
                            <Tooltip key={app.id + "-delete"} title="Delete">
                                <IconButton key={app.id + "-delete-button"} size="small" color="inherit" onClick={() => {
                                    if(confirm(`Are you certain you want to delete Application, ${app.slug}?`)){
                                        Session.api("DELETE", `/applications/${app.id}`, {}, () => {
                                            reloadData();
                                        });
                                    }
                                }}>
                                    <DeleteIcon key={app.id + "-delete-icon"} />
                                </IconButton>
                            </Tooltip>
                        </Typography>
                        <a href={"https://" + fqdn} rel="noopener noreferrer" target="_blank">https://{fqdn}</a>
                        <Typography
                            key={app.id + "-app-body"}
                            variant="body1"
                            align="left"
                            gutterBottom
                            component="p"
                        >
                            Latest update:&nbsp;&nbsp;&nbsp;<DateTimeWidget dt={app.dt_modified} addTimeAgo={true} />
                        </Typography>
                    </div>);
                }

                deployments.push(<div style={{ marginLeft: "3%" }} key={deployment.id + "-container"}>
                    <Typography key={deployment.id + "-deployment-header"} variant="h5" align="left" gutterBottom component="h3">
                        Deployment: {deployment.name} ({deployment.slug})
                    </Typography>
                    <Typography key={deployment.id + "-deployment-body"} variant="body1" align="left" gutterBottom component="p">
                        Latest update: <DateTimeWidget dt={deployment.dt_modified} addTimeAgo={true} />
                    </Typography>
                    <TextField
                        fullWidth={true}
                        key={deployment.id + "-execute-field"}
                        id={deployment.id + "-execute-field"}
                        type="text"
                        helperText="Enter an manager function name."
                        variant="standard"
                        size="medium"
                    />
                    <TextField
                        fullWidth={true}
                        key={deployment.id + "-parameters-field"}
                        id={deployment.id + "-parameters-field"}
                        type="text"
                        helperText="Enter JSON parameters."
                        variant="standard"
                        size="medium"
                    />
                    <Button id={deployment.id + "-execute-button"} variant="contained" color="primary" onClick={() => {
                        let function_name = (document.getElementById(deployment.id + "-execute-field") as HTMLInputElement).value;
                        let parameters = JSON.parse((document.getElementById(deployment.id + "-parameters-field") as HTMLInputElement).value);
                        Session.api("POST", "/tasks/", {
                            name: "Manage " + deployment.name + ": " + function_name,
                            function: "manage_deployment",
                            parameters: {
                                deployment_id: deployment.id,
                                function_name: function_name,
                                parameters: parameters
                            }
                        });
                        Session.navigate("/tasks");
                    }}>Execute Manager Function</Button>
                    <br/>
                    <br/>
                    <Button id={deployment.id + "-apps-button"} variant="contained" color="primary" onClick={() => {
                        let el = (document.getElementById(deployment.id + "-apps") as HTMLElement);
                        let el2 = (document.getElementById(deployment.id + "-apps-button") as HTMLElement);
                        if (el.style.display === "none") {
                            el.style.display = "block";
                            el2.innerHTML = "Hide Applications";
                        } else {
                            el.style.display = "none";
                            el2.innerHTML = "Show Applications";
                        }
                    }}>Show Applications</Button>
                    <div id={deployment.id + "-apps"} style={{ display: "none"}}>
                        {apps}
                    </div>
                    <br/>
                </div>);
            }

            providers.push(<div style={{ marginLeft: "3%" }} key={provider.id + "-container"}>
                <br/>
                <Typography key={provider.id + "-provider-header"} variant="h4" align="left" gutterBottom component="h2">
                    Provider: {provider.name} ({provider.slug})
                </Typography>
                {deployments}
            </div>);
        }

        orgs.push(<div key={org.id + "-container"}>
            <Typography key={org.id + "-org-header"} variant="h4" align="left" gutterBottom component="h2">
                Organization: {org.name} ({org.slug})
            </Typography>
            {providers}
        </div>);
    }

    return <>
        {/* <Typography variant="h4" align="left" gutterBottom component="h2">
            Applications
        </Typography> */}
        {orgs.length === 0 ? <CircularProgress /> : orgs}
    </>
}
